import exerciseCardWhiteStyles from './exercise-card-white.module.less'
import exerciseCardDarkStyles from './exercise-card-dark.module.less'
import styles from './card-style.module.less'
import {
  Image,
  message,
  Button,
  Card,
  Col,
  ConfigProvider,
  Layout,
  Pagination,
  Row,
  Tabs,
  Table,
  Space,
  Popconfirm,
} from 'antd'
import {
  UpOutlined,
  DownOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons'

import { PageHeader } from '../common/page-header/header'
import React, { useEffect, useRef, useState } from 'react'
import PageFooter from '../common/page-footer/footer'
import Search from 'antd/lib/input/Search'

import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '../../constants/constants'
import rehypeHighlight from 'rehype-highlight'
import { Tag } from 'antd'
import Cookies from 'js-cookie'
import { Checkbox } from 'antd'
import { Radio } from 'antd'
const CheckboxGroup = Checkbox.Group

import remarkMath from 'remark-math'
import gfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you

import Meta from 'antd/lib/card/Meta'
import { sendHttpPostRequest } from '../../api/http-request'
//import {checkIsTeacher} from "../../component/modal/teacher-authenticate/teacher-authenticate";
const { CheckableTag } = Tag

const { Content } = Layout
const { TabPane } = Tabs

interface Exercise {
  id: number
  name: string
  author: string
  difficulty: number //难度
  channel: number //
  type: number //题型
  status: number //状态
  create_time: string //创建时间
  modify_time: string //修改时间
}

/* 多选题 */

const optionMap = new Map([
  ['1', 'A'],
  ['2', 'B'],
  ['3', 'C'],
  ['4', 'D'],
])
export interface Props {
  exercise: any
  renderType: string //渲染的主题类型，"dark","white"
  projectId: number
  resultPreview?: boolean
  isSubmit?: boolean
}

export const ExerciseCardMultiSelect: React.FC<Props> = (props) => {
  const { exercise, renderType, projectId, resultPreview, isSubmit } = props

  const options =
    typeof exercise.options === 'string'
      ? JSON.parse(exercise.options)
      : exercise.options
  const [answervisible, setAnswerVisible] = useState(false)
  const [answerList, setAnswerList] = useState(
    exercise?.submit_info?.answer ? exercise?.submit_info?.answer : []
  ) // 选择的答案
  const [running, setRunning] = useState(false) // 运行中状态

  const [currentStatus, setCurrentStatus] = useState(null as any)

  const exerciseCardStyles =
    renderType == 'white' ? exerciseCardWhiteStyles : exerciseCardDarkStyles

  useEffect(() => {
    setAnswerList(
      exercise?.submit_info?.answer ? exercise?.submit_info?.answer : []
    )
  }, [exercise])

  // 习题运行回调
  const runCodeCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
      // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
    } else if (response.code == 0) {
      // 成功
      // TODO: 答题卡片渲染执行结果，不在这里弹提示
      if (response.data.status == true) {
        setCurrentStatus(true)
      } else {
        setCurrentStatus(false)
      }
    } else if (response.code == -501) {
      // 权限不足
      document.getElementById('show-login-modal')!.click()
      // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
    } else {
      message.error(response.message)
    }
    setRunning(false)
  }

  //点击了提交按钮
  const exerciseSubmitBtnClick = () => {
    setRunning(true)
    let data = {
      exercise_id: exercise.id,
      project_id: projectId,
      answer: JSON.stringify(answerList),
    }
    // sendHttpPostRequest(
    //     'exercise/api/exercise_run/',
    //     {
    //         sessionid: Cookies.get("sessionid"),
    //         exercise_id: exercise.id,
    //         project_id: projectId,
    //         answer_list: JSON.stringify(answerList)
    //     },
    //     runCodeCallback
    // )
    sendHttpPostRequest(
      'exercise/api/submit_test_exercise_by_id',
      data,
      runCodeCallback
    )
    /* if (!checkIsTeacher()) {
            document.getElementById("show-teacher-authenticate")!.click();
        } else {
            setRunning(true);
            sendHttpPostRequest(
                'exercise/api/exercise_run/',
                {
                    sessionid: Cookies.get("sessionid"),
                    exercise_id: exercise.id,
                    answer_list: JSON.stringify(answerList)
                },
                runCodeCallback
            )
        }*/
  }

  // 点了复选框
  const onOptionsChange = (checkedValue: any) => {
    setCurrentStatus(null as any)
    /*const option = parseInt(event.target.value);
        let _answerList = answerList;
        const _index = _answerList.indexOf(option);
        if (_index >= 0) {
            _answerList.splice(_index, 1);
        } else {
            _answerList.push(option);
        }
        console.log(_answerList)*/
    //console.log(checkedValue);

    setAnswerList(checkedValue.map(Number))
    exercise.submit_info.answer = checkedValue.map(Number)
  }

  // 看答案回调
  const queryExerciseAnswerCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      // 成功
      if (response.exercise_answer) {
        exercise.options_answer = response.exercise_answer.options_answer
        exercise.answer_parse = response.exercise_answer.answer_parse
        setAnswerVisible(true)
      }
    } else if (response.code == -501) {
      // 权限不足
      // document.getElementById("show-login-modal")!.click();
    } else {
      message.error(response.message)
    }
  }

  //点击了参考答案按钮
  const exerciseAnswerBtnClick = () => {
    if (exercise.options_answer && exercise.options_answer.length == 0) {
      // 查询答案
      sendHttpPostRequest(
        'exercise/api/query_exercise_answer/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          exercise_id: exercise.id,
        },
        queryExerciseAnswerCallback
      )
    } else {
      setAnswerVisible(!answervisible)
    }
  }

  // 渲染 查看答案按钮
  const renderAnswerButton = () => {
    if (exercise.options_answer && 0 == exercise.options_answer.length) {
      return (
        <Popconfirm
          placement="bottom"
          title={'您确定查看答案吗？'}
          onCancel={(e: any) => {
            e.stopPropagation()
          }}
          onConfirm={(e: any) => {
            e.stopPropagation()
            exerciseAnswerBtnClick()
          }}
          okText="确认"
          cancelText="取消"
        >
          <Button
            hidden={true}
            type="link"
            style={{ width: 80, marginRight: 10, borderRadius: 20 }}
          >
            {' '}
            <span>答案解析</span>
            <DownOutlined />{' '}
          </Button>
        </Popconfirm>
      )
    } else {
      return (
        <Button
          hidden={true}
          onClick={exerciseAnswerBtnClick}
          type="link"
          style={{ width: 80, marginRight: 10, borderRadius: 20 }}
        >
          <span>答案解析</span>
          {!answervisible ? <DownOutlined /> : <UpOutlined />}
        </Button>
      )
    }
  }

  const getRunnigStatusBtn = () => {
    if (currentStatus == true) {
      return (
        <Button
          hidden={true}
          onClick={exerciseSubmitBtnClick}
          id={'test-exercise-run-' + exercise.id}
          type="default"
          style={{
            paddingLeft: 5,
            borderRadius: 3,
            width: 80,
            color: '#22c55e',
            borderColor: '#22c55e',
          }}
        >
          {' '}
          <CheckOutlined />正 确
        </Button>
      )
    } else if (currentStatus == false) {
      return (
        <Button
          hidden={true}
          onClick={exerciseSubmitBtnClick}
          id={'test-exercise-run-' + exercise.id}
          danger
          type="default"
          style={{
            paddingLeft: 5,
            color: '#ff4b50',
            borderRadius: 3,
            width: 80,
          }}
        >
          {' '}
          <CloseOutlined />错 误
        </Button>
      )
    } else {
      return (
        <Button
          hidden={true}
          onClick={exerciseSubmitBtnClick}
          loading={running}
          id={'test-exercise-run-' + exercise.id}
          type="primary"
          style={{ borderRadius: 3, width: 80 }}
        >
          {' '}
          测 试{' '}
        </Button>
      )
    }
  }

  return (
    <div
      style={{ marginBottom: 20, textAlign: 'left' }}
      className={exerciseCardStyles.wrapper}
    >
      <div style={{ fontSize: 14 }}>
        <ReactMarkdown
          className={exerciseCardStyles.reactmarkdownTitle}
          remarkPlugins={[gfm, remarkMath]}
          rehypePlugins={[rehypeHighlight, rehypeKatex]}
        >
          {'【多选】' + exercise.title}
        </ReactMarkdown>

        <div style={{ marginTop: 10, marginBottom: 10, position: 'relative' }}>
          {exercise?.images?.map((image: any) => {
            return (
              <div
                key={image.name}
                style={{
                  margin: '10px auto 0px auto',
                  width: '100%',
                  height: '100%',
                  maxWidth: 500,
                  textAlign: 'center',
                }}
              >
                <img
                  width={'100%'}
                  height={'100%'}
                  style={{ backgroundColor: '#f2f2f2', borderRadius: 3 }}
                  src={constants.BACKEND_URL + image.path + image.name}
                />
              </div>
            )
          })}
        </div>
      </div>
      <div className={exerciseCardStyles.optionGroupWrapper} >
        <Checkbox.Group
          onChange={onOptionsChange}
          value={exercise?.submit_info?.answer?.map(String)}
          disabled={isSubmit && resultPreview}
        >
          <Space size="small" direction="vertical">
            {options.map((option) => {
              return (
                <div
                  style={{ width: '100%' }}
                  className={exerciseCardStyles.option}
                  key={option.id}
                >
                  <Checkbox
                    id={`exercise-${exercise.id}-option-${option.id}`}
                    style={{
                      padding: 5,
                      minHeight: 30,
                     //marginLeft: 20,
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center',
                    }}
                    key={option.id}
                    value={option.id}
                  >
                    <div>
                      <ReactMarkdown
                        className={
                          exerciseCardStyles.reactmarkdownOption +
                            ' ' +
                            isSubmit && resultPreview
                            ? exercise?.answer?.includes(option.id - 0)
                              ? styles.rigthOpt
                              : !exercise?.answer?.includes(option.id - 0) &&
                                exercise?.submit_info?.answer?.includes(
                                  option.id - 0
                                )
                              ? styles.errorOpt
                              : renderType == 'white'
                              ? styles.defaultWhite
                              : styles.default
                            : renderType == 'white'
                            ? styles.defaultWhite
                            : styles.default
                        }
                        remarkPlugins={[gfm, remarkMath]}
                        rehypePlugins={[rehypeKatex, rehypeRaw]}
                      >
                        {option.id + '. ' + option.options}
                      </ReactMarkdown>
                    </div>
                  </Checkbox>
                </div>
              )
            })}
          </Space>
        </Checkbox.Group>
      </div>

      <Row
        justify="start"
        align="middle"
        gutter={[8, 8]}
        style={{ height: '10px' }}
        // style={{ marginTop: 20 }}
      >
        <Col flex={'100px'} style={{ textAlign: 'left' }}>
          {getRunnigStatusBtn()}
        </Col>
        <Col flex={'auto'} style={{ textAlign: 'left' }}></Col>
        <Col flex={'100px'} style={{ textAlign: 'right' }}>
          {renderAnswerButton()}
        </Col>
      </Row>

      {isSubmit && resultPreview && (
        <div className={styles.resultContain}>
          <div
            className={
              renderType == 'white' ? styles.whiteTitle : styles.resultTitle
            }
          >
            答案解析
          </div>
          <ReactMarkdown
            className={exerciseCardStyles.reactmarkdown}
            remarkPlugins={[gfm, remarkMath]}
            rehypePlugins={[rehypeKatex, rehypeRaw]}
          >
            {exercise.answer_parse}
          </ReactMarkdown>
          {/* <div className={styles.resultConstent}>{exercise.answer_parse}</div> */}
        </div>
      )}

      {answervisible && (
        <div
          style={{ marginTop: 20, padding: 10, borderRadius: 5 }}
          className={exerciseCardStyles.answerParse}
        >
          <ReactMarkdown
            className={exerciseCardStyles.reactmarkdown}
            remarkPlugins={[gfm, remarkMath]}
            rehypePlugins={[rehypeKatex, rehypeRaw]}
          >
            {exercise.answer_parse}
          </ReactMarkdown>
        </div>
      )}
    </div>
  )
}

export default ExerciseCardMultiSelect
